export const setUserDetails = (store, username, firstname, lastname, email) => {
    const newUserDetails = { 
        username: username, 
        firstname: firstname,
        lastname: lastname,
        email: email
    };
    store.setState({ userDetails: newUserDetails });
};